export default "__VITE_ASSET__dc31c7a9__"